import React from "react";
import styled from "styled-components";
import { Button } from "../button";
import { Logo } from "../logo";
import { Marginer } from "../marginer";

const NavbarContainer = styled.div`
  width: 100%;
  height: 50px;
  padding: 0 2em;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 600px) {
    padding: 0 0.5em;
  }
`;

const BrandContainer = styled.div``;

const AccessibilityContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const LoginButton = styled(Button)`

  &:hover {
    color: #8d0303;
  }
`;

export function Navbar(props) {
  return (
    <NavbarContainer>
      <BrandContainer>
        <Logo inline />
      </BrandContainer>
      <AccessibilityContainer>
        <a href="https://skideo.tv"><Button small>Start Learning</Button></a>
        <Marginer direction="horizontal" margin="8px"/>
        <a href="https://skideo.tv/auth/login"><LoginButton small>Login</LoginButton></a>
      </AccessibilityContainer>
    </NavbarContainer>
  );
}
